import { useContext, useState, useEffect } from 'react';
import './pane-right-tasks-header.scss';
import { CheckBox } from 'devextreme-react/check-box';
import { TextBox } from 'devextreme-react/text-box';

const TaskHeader = ({ handleSelectAll, handleSearch, handleCompact, handleComplete, isSelectAll }) => {

    const [timeoutId, setTimeoutId] = useState(null);
    const [isCompact, setIsCompact] = useState(localStorage.getItem('isCompact') === 'true');
    /*const [isComplete, setIsComplete] = useState(isSelected);*/
    const isSelected = false;

    

    const handleCheckBoxOnValueChanged = (e) => {
        handleSelectAll(e.value);
    };

    const handleTextBoxOnValueChanged = (e) => {

        if (timeoutId) {
            clearTimeout(timeoutId);
        }

        const newTimeoutId = setTimeout(() => {
            handleSearch(e.value);
        }, 1000);

        setTimeoutId(newTimeoutId);
    };

    const handleCompactClick = (e) => {
        setIsCompact(!isCompact);
        handleCompact(!isCompact);
    };

    const handleCompleteClick = (e) => {
        handleComplete();
    }

    useEffect(() => {
        localStorage.setItem('isCompact', isCompact);
    }, [isCompact]);


    return (

        <div className="list-tasks-header">
            <CheckBox
                value={isSelectAll}
                onValueChanged={handleCheckBoxOnValueChanged} text="Вибрати всі завдання" />
            <TextBox className="txtSearch"
                placeholder="Шукати..."
                mode="search"
                valueChangeEvent="keyup"
                onValueChanged={handleTextBoxOnValueChanged}
            />

            <div style={{ display: "inline-flex", marginLeft: "auto" }}>

                <div className={isCompact ? "btnCompactMode" : "btnFullMode"}
                    title={isCompact ? "Переключити у повний вигляд завдань" : "Переключити у компактний вигляд завдань"}
                    onClick={handleCompactClick}>
                </div>

                <div id="btnCompleteTask" className={isSelected ? "btnCompleteSelected" : "btnComplete"}
                    title="Завершити обрані завдання"
                    disabled={isSelected ? false : true}
                    onClick={handleCompleteClick}>
                </div>
            </div>
        </div>

    );
};

export default TaskHeader;



